/* unplugin-vue-components disabled */import script from "./Evaluate.vue?vue&type=script&setup=true&name=Evaluate&lang=js"
export * from "./Evaluate.vue?vue&type=script&setup=true&name=Evaluate&lang=js"

import "./Evaluate.vue?vue&type=style&index=0&id=15c1d948&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15c1d948"]])

export default __exports__